'use client';

import Image from 'next/image';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function Divider({ className }: { className?: string }) {
  return (
    <div className={cn('custom-section', 'relative py-8 sm:py-10 md:py-12 lg:py-16', className)}>
      <Image
        src={'/images/icons/d.svg'}
        alt="Diely na okná"
        width={0}
        height={0}
        className="absolute left-1/2 top-1/2 z-10 h-[28px] w-auto -translate-x-1/2 -translate-y-1/2 bg-white"
      />
      <div className={cn('custom-container', 'h-[1px] bg-primary')} />
    </div>
  );
}
